import { forwardRef, useState } from 'react';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useMedia } from 'use-media';

import { Review } from 'entities/application/types';
import { ApplicationReview } from 'entities/application/ui/ApplicationReview/ApplicationReview';
import {
	ApplicationReviewsStyled,
	BackButton,
	ForwardButton,
} from 'entities/application/ui/ApplicationReviews/ApplicationReviews.styles';
import { MpBlock } from 'shared/ui/MpBlock';
import { MpTitle } from 'shared/ui/MpTitle';

interface Props {
	reviews: Review[];
}

const DESKTOP_TRESHOLD = 3;
const MOBILE_TRESHOLD = 2;

export const ApplicationReviews = forwardRef<HTMLElement, Props>(({ reviews }, ref) => {
	const [currIndex, setCurrIndex] = useState(0);

	const forward = (): void => setCurrIndex(currIndex + 1);
	const back = (): void => setCurrIndex(currIndex - 1);

	const isDesktop = useMedia({ minWidth: `1200px` });

	return (
		<MpBlock ref={ref}>
			<MpTitle level={2}>Отзывы</MpTitle>
			<div style={{ position: `relative` }}>
				<ApplicationReviewsStyled>
					{reviews.map(n => (
						<ApplicationReview
							title={n.title}
							content={n.content}
							author={n.author}
							date={n.date}
							key={n.title}
							avatarUrl={n.avatarUrl}
							currIndex={currIndex}
						/>
					))}
				</ApplicationReviewsStyled>
				{currIndex >= 1 && (
					<BackButton shape='circle' size='large' icon={<ArrowLeftOutlined />} onClick={back} />
				)}
				{currIndex <= reviews.length - (isDesktop ? DESKTOP_TRESHOLD : MOBILE_TRESHOLD) && (
					<ForwardButton shape='circle' size='large' icon={<ArrowRightOutlined />} onClick={forward} />
				)}
			</div>
		</MpBlock>
	);
});
